module.exports = __webpack_public_path__ + "static/media/auth_after.b5a35666.png";